import { Search, X } from "lucide-react";
import { forwardRef, useState, type KeyboardEvent } from "react";
import { cn } from "@/lib/utils";

interface SearchInputProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(function SearchInput(
  { placeholder = "Buscar paciente", value, onChange, onKeyDown },
  ref
) {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div
      className={cn(
        "relative flex items-center w-full bg-white rounded-xl border transition-all duration-200",
        isFocused ? "border-primary shadow-sm ring-2 ring-primary/10" : "border-border shadow-sm"
      )}
    >
      <Search className="absolute left-4 h-4 w-4 text-muted-foreground/70" />
      <input
        ref={ref}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onKeyDown={onKeyDown}
        className="w-full h-11 pl-11 pr-10 bg-transparent text-[0.9rem] font-medium text-foreground placeholder:text-muted-foreground/60 placeholder:font-normal focus:outline-none"
      />
      {value && (
        <button
          onClick={() => onChange("")}
          className="absolute right-3 p-1 rounded-full text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
});


